import {Directive, ElementRef, HostListener, OnDestroy, OnInit} from '@angular/core';

@Directive({
    selector: '[modalTrap]',
    exportAs: 'modal-trap'
})

export class ModalTrap implements OnDestroy, OnInit {
    KEYCODE_TAB: number = 9;

    constructor(
        private hostElement: ElementRef
    ) {}

    ngOnInit() {
    }

    ngOnDestroy() {}

    @HostListener("keydown", ["$event"])
    onKeyDown(e: KeyboardEvent): any {
        if (e.keyCode === 9 || e.keyCode === this.KEYCODE_TAB) {
            const focusableEls1 = this.hostElement.nativeElement.querySelectorAll(
                '[tabindex="0"]' 
              );
              console.log('===========focus elements',focusableEls1)
              const focusableEls = Array.from(focusableEls1)
                .filter( (el: any) => !el.disabled);
              const firstFocusableEl: any = focusableEls[0];  
              const lastFocusableEl: any = focusableEls[focusableEls.length - 1];
          
              this.hostElement.nativeElement.addEventListener('keydown', (e : any) => {
                var isTabPressed = e.keyCode === 9; // isTabPressed
                if (!isTabPressed) return;
          
                if ( e.shiftKey ) /* shift + tab */ {
                  console.log(document.activeElement, "document.activeElement");
                  if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                  }
                } else /* tab */ {
                  if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                  }
                }
              });
        }
    }
}